// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ClientesPreencher_PublicUpdateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /clientes/preencher/update
 *
 * Public endpoint — no authentication required.
 * Token identifies the customer. Only whitelisted fields are accepted.
 * Fields like cliente_nome, cliente_telefone, cliente_franquia_id
 * are intentionally excluded to prevent privilege escalation.
 */
import { registerContract } from './validate'

export interface ClientesPreencher_PublicUpdateInput {
token: string
cliente_email?: string
cliente_cpf?: string
cliente_document_type?: string
cliente_data_nascimento?: string
cliente_genero?: string
cliente_cep?: string
cliente_rua?: string
cliente_numero?: string
cliente_complemento?: string
cliente_bairro?: string
cliente_origem_id?: number
cliente_obs?: string
}

registerContract('ClientesPreencher_PublicUpdateInput', {
  token:                   { type: 'string',  required: true },
  cliente_email:           { type: 'string',  required: false },
  cliente_cpf:             { type: 'string',  required: false },
  cliente_document_type:   { type: 'string',  required: false },
  cliente_data_nascimento: { type: 'string',  required: false },
  cliente_genero:          { type: 'string',  required: false },
  cliente_cep:             { type: 'string',  required: false },
  cliente_rua:             { type: 'string',  required: false },
  cliente_numero:          { type: 'string',  required: false },
  cliente_complemento:     { type: 'string',  required: false },
  cliente_bairro:          { type: 'string',  required: false },
  cliente_origem_id:       { type: 'number',  required: false },
  cliente_obs:             { type: 'string',  required: false },
})
